<template>
  <div class="product-inventory-section">
    <div class="row py-8 px-8 py-lg-15 px-lg-10">
      <div class="col-xl-12">
        <!--begin: Chi tiết-->
        <div class="pb-5 full-width">
          <b-row>
            <b-col cols="12" md="3">
              <b-form>
                <b-form-group id="input-group-id" label-for="input-name">
                  <Autosuggest
                    :model="searchStock"
                    :suggestions="filteredOptions"
                    :placeholder="'kho'"
                    :limit="10"
                    @select="onSelected"
                    @change="onInputChange"
                    suggestionName="suggestionName"
                  />
                </b-form-group>
              </b-form>
            </b-col>
            <b-col cols="12" md="1">
              <b-button
                variant="primary"
                size="sm"
                @click="getProductStock"
                style="fontweight: 600; width: 70px"
                >Lọc</b-button
              >
            </b-col>
            <b-col md="3" class="text-left">
              <b-button
                variant="outline-primary"
                @click="showHistoryModal"
                class="d-flex align-items-center"
                size="sm"
              >
                <i class="fas fa-history"></i>
                Xem lịch sử tồn
              </b-button>
            </b-col>
          </b-row>

          <b-table
            :items="detailItems"
            :fields="detailFields"
            bordered
            hover
            :busy="onLoadingDetail"
          >
            <template v-slot:table-busy>
              <vcl-table :speed="5" :animate="true" :columns="9"></vcl-table>
            </template>
            <template v-slot:cell(quantity)="row">
              <div style="text-align: end">
                <span v-text="row.item.quantity"></span>
              </div>
            </template>
            <template v-slot:cell(inStockQuantity)="row">
              <div style="text-align: end">
                <span v-text="row.item.inStockQuantity"></span>
              </div>
            </template>
            <template v-slot:cell(deliveryQuantity)="row">
              <div style="text-align: end">
                <span v-text="row.item.deliveryQuantity"></span>
              </div>
            </template>
            <template v-slot:cell(transferQuantity)="row">
              <div style="text-align: end">
                <span v-text="row.item.transferQuantity"></span>
              </div>
            </template>
            <template v-slot:cell(holdingQuantity)="row">
              <div style="text-align: end">
                <span v-text="row.item.holdingQuantity"></span>
              </div>
            </template>
            <template v-slot:cell(warrantyQuantity)="row">
              <div style="text-align: end">
                <span v-text="row.item.warrantyQuantity"></span>
              </div>
            </template>
            <template v-slot:cell(ctb)="row">
              <div style="text-align: end">
                <span v-text="row.item.ctb"></span>
              </div>
            </template>
          </b-table>
        </div>
        <!--end: Chi tiết-->
      </div>
    </div>

    <!-- History Modal -->
    <inventory-history-modal
      ref="inventory-history-modal"
      :product-id="productId"
      :product-code="productCode"
      :is-visible="showHistoryModalFlag"
      @close="closeHistoryModal"
      :selected-store-id="selectedStore"
      :selected-store-name="searchStock"
    />
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import { VclTable } from 'vue-content-loading';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import InventoryHistoryModal from './modals/InventoryHistoryModal.vue';

export default {
  name: 'ProductInventorySection',
  props: {
    productId: {
      type: [Number, String],
      required: true,
    },
    productCode: {
      type: String,
      default: '',
    },
    productName: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      detailFields: [
        {
          thStyle: { textAlign: 'center' },
          key: 'count',
          label: 'STT',
          tdClass: 'sttClass',
          thClass: 'sttClass',
        },
        {
          thStyle: { textAlign: 'center' },
          key: 'store',
          label: 'Kho',
          tdClass: 'storeClass',
          thClass: 'storeClass',
        },
        {
          thStyle: { textAlign: 'center' },
          key: 'quantity',
          label: 'SL',
          tdClass: 'quantityClass',
        },
        {
          thStyle: { textAlign: 'center' },
          key: 'inStockQuantity',
          label: 'Tồn trong kho',
          tdClass: 'quantityClass',
        },
        {
          thStyle: { textAlign: 'center' },
          key: 'deliveryQuantity',
          label: 'Đang giao',
          tdClass: 'quantityClass',
        },
        {
          thStyle: { textAlign: 'center' },
          key: 'transferQuantity',
          label: 'Đang chuyển',
          tdClass: 'quantityClass',
        },
        {
          thStyle: { textAlign: 'center' },
          key: 'holdingQuantity',
          label: 'Đang giữ hàng',
          tdClass: 'quantityClass',
        },
        {
          thStyle: { textAlign: 'center' },
          key: 'warrantyQuantity',
          label: 'Đang bảo hành',
          tdClass: 'quantityClass',
        },
      ],
      detailItems: [],
      filteredOptions: [],
      options: [
        {
          data: [],
        },
      ],
      searchStock: '',
      listStore: [],
      onLoadingDetail: false,
      selectedStore: null,
      showHistoryModalFlag: false,
    };
  },
  components: {
    VclTable,
    Autosuggest,
    InventoryHistoryModal,
  },
  watch: {
    active: {
      immediate: true,
      handler(newVal) {
        if (newVal && this.productId) {
          this.getProductStock();
        }
      },
    },
    productId: {
      immediate: true,
      handler(newVal) {
        if (newVal && this.active) {
          this.getProductStock();
        }
      },
    },
  },
  created() {
    this.fetchStore();
  },
  methods: {
    onSelected(option) {
      this.searchStock = option.item.name;
      this.selectedStore = option.item.id;
    },
    onInputChange(text) {
      if (!text) {
        text = '';
      }
      this.searchStock = text;

      const filteredData = this.options[0].data
        .filter((item) => {
          return (
            item.name.toLowerCase().indexOf(text.toLowerCase()) > -1 ||
            item.shortName.toLowerCase().indexOf(text.toLowerCase()) > -1
          );
        })
        .slice(0, this.limit);

      this.filteredOptions = [...filteredData];
    },
    convertPrice: function (number) {
      return new Intl.NumberFormat('vn-VN').format(number);
    },
    getProductStock: function () {
      if (!this.searchStock || this.searchStock.trim() === '') {
        this.selectedStore = null;
      }

      const param = {
        storeId: this.selectedStore,
      };
      const paramQuery = {
        params: param,
      };
      this.onLoadingDetail = true;
      ApiService.query(`v1/product-stocks/${this.productId}`, paramQuery)
        .then(({ data }) => {
          if (data.status === 200) {
            this.detailItems = [];
            let count = 1;
            data.data.listStockDetail.forEach((element) => {
              let ctb =
                element.quantity -
                element.holdingQuantity -
                element.warrantyQuantity;
              if (ctb < 0) {
                ctb = 0;
              }
              let item = {
                count: count,
                store: element.storeName,
                quantity: element.quantity !== 0 ? element.quantity : '',
                inStockQuantity:
                  element.inStockQuantity !== 0 ? element.inStockQuantity : '',
                deliveryQuantity:
                  element.deliveryQuantity !== 0
                    ? element.deliveryQuantity
                    : '',
                transferQuantity:
                  element.transferQuantity !== 0
                    ? element.transferQuantity
                    : '',
                holdingQuantity:
                  element.holdingQuantity !== 0 ? element.holdingQuantity : '',
                warrantyQuantity:
                  element.warrantyQuantity !== 0
                    ? element.warrantyQuantity
                    : '',
                ctb: ctb !== 0 ? ctb : '',
              };
              this.detailItems.push(item);
              count++;
            });
          } else {
            this.makeToastFaile('Tải dữ liệu thất bại!');
          }
          this.onLoadingDetail = false;
        })
        .catch(({ response }) => {
          this.onLoadingDetail = false;
          this.makeToastFaile(response.$error);
        });
    },
    showHistoryModal() {
      this.showHistoryModalFlag = true;
      this.$refs['inventory-history-modal'].showModal();
    },
    closeHistoryModal() {
      this.showHistoryModalFlag = false;
    },
    fetchStore: async function () {
      this.options[0].data = [];
      ApiService.get('/stores/getStores').then((response) => {
        const stores = response.data.data;
        this.listStore = stores;
        stores.map((element) => {
          let store = {
            id: element.id,
            name: element.name,
            shortName: element.shortName,
            suggestionName: element.shortName + ' ( ' + element.name + ')',
          };
          this.options[0].data.push(store);
        });
        this.filteredOptions = [...this.options[0].data];
      });
    },
    makeToastFaile(message) {
      this.$bvToast.toast(message, {
        title: 'Lỗi',
        variant: 'danger',
        solid: true,
        autoHideDelay: 3000,
      });
    },
  },
};
</script>

<style lang="scss">
.product-inventory-section {
  .sttClass {
    width: 3%;
    text-align: center;
  }
  .storeClass {
    width: 17%;
  }
  .quantityClass {
    width: 8.5%;
  }
  .unitPriceClass {
    width: 13.5%;
  }
  .totalPriceClass {
    width: 14.5%;
  }
  .productCode:hover {
    text-decoration: underline;
    cursor: pointer;
    color: #3699ff;
  }
}
</style>
